var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _vm.prescriptionObjectIsPopulated
    ? _c(
        "div",
        { staticClass: "rb-rox-prescription" },
        [
          _c(
            "button",
            {
              staticClass: "rb-rox-prescription-button",
              class: {
                "rb-rox-prescription-button--cursor-auto": !_vm.isModalEnabled,
              },
              on: { click: _vm.openModal },
            },
            [
              _c("rb-message-box", {
                attrs: { type: _vm.messageBoxType },
                scopedSlots: _vm._u(
                  [
                    {
                      key: "text",
                      fn: function () {
                        return [
                          _vm.isButtonIcon
                            ? _c("span", {
                                staticClass:
                                  "common__icon common__icon--info-big",
                              })
                            : _vm._e(),
                          _vm._v(" "),
                          _c(
                            "span",
                            {
                              staticClass: "rb-rox-prescription-button__label",
                              class: {
                                "rb-rox-prescription-button__label--underlined":
                                  _vm.isModalEnabled,
                              },
                            },
                            [_vm._v(_vm._s(_vm.buttonLabel))]
                          ),
                        ]
                      },
                      proxy: true,
                    },
                  ],
                  null,
                  false,
                  3941497370
                ),
              }),
            ],
            1
          ),
          _vm._v(" "),
          _vm.isModalEnabled
            ? [
                _c("rb-modal", {
                  attrs: {
                    show: _vm.isModalVisible,
                    "handle-close": _vm.closeModal,
                    "modal-wrapper-class": _vm.modalWrapperClass,
                    "modal-class-container": _vm.modalClassContainer,
                  },
                  scopedSlots: _vm._u(
                    [
                      {
                        key: "modal-header",
                        fn: function () {
                          return [
                            _c(
                              "div",
                              { staticClass: "rb-modal-header__title" },
                              [_vm._t("title")],
                              2
                            ),
                            _vm._v(" "),
                            !_vm.isUploadPrescriptionObject
                              ? _c(
                                  "div",
                                  { staticClass: "rb-modal-header__subtitle" },
                                  [_vm._t("subtitle")],
                                  2
                                )
                              : _vm._e(),
                          ]
                        },
                        proxy: true,
                      },
                      {
                        key: "modal-content",
                        fn: function () {
                          return [
                            _vm.isUploadPrescriptionObject
                              ? _c("rb-rox-upload-prescription", {
                                  attrs: {
                                    "upload-prescription-object":
                                      _vm.prescriptionObject,
                                  },
                                })
                              : _c("rb-rox-manual-prescription", {
                                  attrs: {
                                    "manual-prescription-object":
                                      _vm.prescriptionObject,
                                  },
                                }),
                          ]
                        },
                        proxy: true,
                      },
                    ],
                    null,
                    true
                  ),
                }),
                _vm._v(" "),
                _vm.withModalPortal
                  ? _c("modal-portal", { staticClass: "modal-wrapper--main" })
                  : _vm._e(),
                _vm._v(" "),
                _vm.isInPaymentPage
                  ? _c("modal-portal", {
                      staticClass: "modal-wrapper--rox-prescription",
                    })
                  : _vm._e(),
              ]
            : _vm._e(),
        ],
        2
      )
    : _vm._e()
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }